export { ConfigurationsPageContent } from './components/configurations-page-content';
export {
  configurationQueries,
  configurationKeys
} from './services/configurations.queries';
export { useUpdateAppSettingsMutation } from './services/configurations.mutations';
export {
  useAppSettings,
  useQa2OcrStageEnabled,
  useHardwareScannerEnabled,
  useNotificationsEnabled,
  useOcrHighlightsEnabled,
  useOcrDefaultHighlightColor,
  DEFAULT_OCR_HIGHLIGHT_COLOR,
  useMaxPdfUploadFiles,
  useMaxScanPages,
  useScanPageQuota,
  useDynamicFormLabMode,
  useLabelPrintConfig,
  useGridPrintConfig,
  useContinuousPrintConfig,
  useActiveZebraPrinterUid,
  useZebraPrinterProfiles
} from './hooks/use-app-settings';
export {
  useSingleQrPrint,
  type SingleQrPrintResult,
  type CopyZplResult
} from './hooks/use-single-qr-print';
export type {
  AppSettings,
  RejectionReason,
  OfficeBiLabel,
  ScanPageQuota
} from './types';
